/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


{
  // ターゲットとなるノードを取得
  const targetNode = document.getElementById('staffstart-shopify-app-container');

  if (targetNode) {
    // オプションを設定（子ノード、子孫ノード、属性の変化を監視）
    const config = { childList: true, subtree: true };

    // コールバック関数を作成
    const callback = function(mutationsList, observer) {
      for(let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          setTimeout(() => {
            const btn = document.querySelector('.sc-bkEOxz.kigVwu');
            if (btn) {
              const textContents = document.querySelectorAll('.sc-isRoRg.hSyogT');
              let isLCF = false;
              textContents.forEach(e => {
                if (e.textContent.includes('LCF')) {
                  isLCF = true;
                }
              });
              if (!isLCF) {
                btn.style.backgroundColor = '#3d4976';
              }
            }
            observer.disconnect();
          }, 500);
        }
      }
    };

    // Observerインスタンスを生成
    const observer = new MutationObserver(callback);

    // 監視を開始
    observer.observe(targetNode, config);
  }
}

{
  const note = document.getElementById('cart-note');
  const giftCheckbox = document.getElementById('checkBoxGiftWrappingPC');

  // if (giftCheckbox) {
    // giftCheckbox.addEventListener('change', function() {
      // document.getElementById('js_attributesGift').setAttribute('value', giftCheckbox.checked);
      // giftCheckbox.setAttribute('value', giftCheckbox.checked ? 'Yes' : 'No');
    // });
  // }

  document.addEventListener('DOMContentLoaded', function() {
    if (note) {
      note.value = '';
    }
  });

  const fakeCheckoutBtns = document.querySelectorAll('.js_fakeCheckoutBtn');
  const checkoutBtn = document.getElementById('js_checkoutBtn');
  if (fakeCheckoutBtns) {
    fakeCheckoutBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        updateCartNote();
      });
    });
  }

  function updateCartNote() {
    const giftCheckbox = document.getElementById('checkBoxGiftWrappingPC');
    const giftMessage = document.getElementById('rteWrappingMessage');
    const noshiCheckbox = document.getElementById('GiftBow');
    const noshi = document.getElementById('optionbow');
    const noshiMessage = document.getElementById('rteSenderMessage');
    const messageCheckbox = document.getElementById('checkGiftMessage');
    const message = document.getElementById('rteMessage');
    const deliveryCheck = document.getElementById('js_showDeliveryDate');
    const delivery = document.getElementById('delivery-time');
    const fakeNote = document.getElementById('cart-note-fake');
    let noteValue = ''
    // document.getElementById('checkBoxGiftWrappingPC').setAttribute('value', giftCheckbox.getAttribute('value') === 'Yes' ? 'Yes' : 'No');
    if (giftCheckbox.checked) {
      noteValue = noteValue + '【ラッピング】：Yes' + '\n\n'
    }
    if (giftCheckbox.checked && giftMessage.value.length > 0) {
      noteValue = noteValue + '【ギフトラッピング】: ' + giftMessage.value + '\n\n'
    }
    if (noshiCheckbox.checked && noshi.value != 'No' || noshiMessage.value.length > 0) {
      noteValue = noteValue + '【のし】: ';
      if (noshi.value != 'No') {
        noteValue = noteValue + noshi.value + '\n\n';
      }
      if (noshiMessage.value.length > 0) {
        noteValue = noteValue + '【のしの名入れ】' + noshiMessage.value + '\n\n'
      }
    }
    if (messageCheckbox.checked && message.value.length > 0) {
      noteValue = noteValue + '【メッセージ】: ' + message.value + '\n\n'
    }
    if (deliveryCheck.classList.contains('is-show') && delivery.value != '指定なし' ) {
      noteValue = noteValue + '【配送時間帯】: ' + delivery.value + '\n\n'
    }
    if (fakeNote.value != '') {
      noteValue = noteValue + '【配送備考】: ' + fakeNote.value + '\n\n'
    }
    note.value = noteValue;

    fetch(window.routes.cartUrl + '/update.js', {
      body: JSON.stringify({ note: noteValue }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    })
      .then(res => res.json())
      .then(data => {
        checkoutBtn.click();
      });
  }
}